import './applicationCard.scss';

import { ReactNode, useState } from 'react';
import { Link } from 'react-router-dom';

import VehicleImagePlaceholder from '../../assets/vehicle-placeholder.png';
import { partnerBadgeAssets } from './constants/partnerBadgeAssets';
import { ApplicationCardProps } from './types/ApplicationCardProps';

export const ApplicationCard = ({
  applicationDescription,
  brand,
  defaultImage,
  description,
  id,
  testId,
}: ApplicationCardProps): ReactNode => {
  const [imageFailedToLoad, setImageFailedToLoad] = useState(false);

  return (
    <li data-testid={testId}>
      <Link className="application-card" to={`/dashboard/application/${id}`}>
        <figure>
          <img
            alt={description}
            className="application-card-image"
            src={
              defaultImage && !imageFailedToLoad
                ? defaultImage
                : VehicleImagePlaceholder
            }
            onError={(): void => {
              setImageFailedToLoad(true);
            }}
          />
          {brand && (
            <img
              alt={brand}
              className="partner-badge"
              src={partnerBadgeAssets[brand]}
            />
          )}
        </figure>
        <div className="application-card-content">
          <p className="card-title">{description}</p>
          <p className="card-subtitle">{applicationDescription}</p>
        </div>
      </Link>
    </li>
  );
};
